import pinyin from 'pinyin';
import isEmpty from 'lodash/isEmpty';
import { loadDictionary } from '../shared/hooks/dictionary';

export const generatePinyin = async (text) => {
  let pinyins = [];
  let currentNonChineseText;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const autoCharPinyin = pinyin(char)[0][0];

    if (autoCharPinyin === char) {
      currentNonChineseText = currentNonChineseText ?? '';
      currentNonChineseText += char;
      continue;
    } else if (currentNonChineseText) {
      pinyins.push(currentNonChineseText);
      currentNonChineseText = undefined;
    }

    const pinyinsAdded = await getPinyinFromDictionary(text.substring(i));

    if (pinyinsAdded.length === 0) {
      pinyins.push(autoCharPinyin);
      continue;
    }

    pinyins.push(...pinyinsAdded);
    i += pinyinsAdded.length - 1;
  }

  if (currentNonChineseText) {
    pinyins.push(currentNonChineseText);
    currentNonChineseText = undefined;
  }

  return pinyins;
};

const getPinyinFromDictionary = async (text) => {
  const dictionary = await loadDictionary();
  const { data: results = [] } = dictionary.wordSearch(text) ?? {};

  if (results.length === 0) {
    return results;
  }

  const parsedResults = dictionary.parseResults(results);

  // all results got censored, return the pinyin from pinyin lib as the only pinyin possible
  if (isEmpty(parsedResults)) {
    const [[, word]] = results;
    return pinyin(word).map(([p]) => p);
  }

  const sortedResults = [...parsedResults].sort(({ pinyin: aPinyin }, { pinyin: bPinyin }) => {
    [aPinyin, bPinyin] = [aPinyin, bPinyin].map((pinyin) => pinyin.split(' '));

    if (aPinyin.length !== bPinyin.length) {
      return bPinyin.length - aPinyin.length;
    }

    const isALowerCase = aPinyin[0] === aPinyin[0].toLowerCase();
    const isBLowerCase = bPinyin[0] === bPinyin[0].toLowerCase();

    if (isALowerCase === isBLowerCase) {
      return 0;
    }

    return isALowerCase ? -1 : 1;
  });

  const [{ pinyin: dictPinyin }] = sortedResults;

  return dictPinyin.split(' ');
};
